import PrivateNavBar from './PrivateNavBar';
export default PrivateNavBar;
